/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit User/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Avatar from './Avatar/index'
import Company from './Company/index'
import ExternalProfessionalInfo from './ExternalProfessionalInfo/index'
import Name from './Name/index'
import React from 'react'
import Tag from './Tag/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function User({
  children,
  viewPath = "/App/ChooseUser/Users/Content/User",
  isSubmitting
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let selectedIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
let userItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'user_item',
path: 'isFirst',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting,
  isHovered
  
})
  return (<React.Fragment
>
<div
  data-testid="User.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={selectedIsSubmittingData}
 style={{'--pl-4-bE5X': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-5-bE5X': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-2-bE5X': isHovered ? dtColorsWhite : dtColorsNeutral200,'--bc-1-bE5X': isHovered ? dtColorsNeutral200 : dtColorsWhite,'--mt-3-bE5X': userItemIsFirstValueData ? "0px" : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
/>
<div
  data-testid="User.Vertical"
  data-view-path={viewPath}
 style={{'--ml-6-bE5X': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="User.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Company
  viewPath={`${viewPath}/Company`}
/>
</div>
<ExternalProfessionalInfo
  viewPath={`${viewPath}/ExternalProfessionalInfo`}
/>
<Tag
  viewPath={`${viewPath}/Tag`}
/>
</div>
</div>
{children}
</React.Fragment>)
}